import View from './view';

export const CardServicesScreen = View;
